/**
 * Terminología de la marca: renombra las entidades visibles (edificio,
 * portfolio, planta...) sin tocar el resto de textos.
 *
 * Es una lista cerrada. Cada término es un nombre de entidad y se aplica solo
 * a los mensajes de i18n que son exactamente ese nombre; las frases que lo
 * contienen («Estás consultando los edificios de...») no se tocan. El valor del
 * término es un texto (todos los idiomas) o un objeto por idioma, y un idioma
 * sin texto conserva su traducción.
 *
 * Las claves deben coincidir con `TERM_KEYS` de `branding/schema.py`.
 */
export const TERM_MESSAGES = {
  portfolio: [
    'building.portfolio',
    'building.portfolio.group',
    'administration.homescreen.portofolio',
    'administration.accounts.selector.homescreen.portfolio',
    'widgets.node_type.portfolio',
  ],
  space: [
    'administration.homescreen.space',
    'administration.accounts.selector.homescreen.space',
    'building.parent_space',
  ],
  spaces: ['menu.cities', 'administration.cities'],
  building: [
    'menu.building',
    'administration.homescreen.building',
    'administration.accounts.selector.homescreen.building',
    'administration.group.building',
    'widgets.node_type.building',
  ],
  buildings: ['menu.buildings', 'administration.buildings'],
  subbuilding: [
    'administration.group.subbuilding',
    'widgets.node_type.subbuilding',
  ],
  subbuildings: ['dashboard.sub.buildings'],
  floor: ['building.floor'],
  floors: ['menu.floors'],
  client: [
    'administration.homescreen.client',
    'administration.accounts.selector.homescreen.client',
    'building.client',
    'administration.group.client',
    'widgets.node_type.client',
  ],
  clients: ['menu.customers'],
};

const textFor = (value, lang) =>
  typeof value === 'string' ? value : value && value[lang];

/**
 * Mezcla los términos sobre los mensajes de cada idioma (en el sitio: el
 * IntlProvider lee el mismo objeto). Solo sustituye mensajes que ya existen.
 * Devuelve cuántos mensajes cambió.
 */
export const applyTerms = (appLocale, terms) => {
  let changed = 0;
  if (!appLocale || !terms) return changed;
  Object.keys(terms).forEach((term) => {
    const ids = TERM_MESSAGES[term];
    if (!ids) return;
    Object.keys(appLocale).forEach((lang) => {
      const messages = appLocale[lang] && appLocale[lang].messages;
      const text = textFor(terms[term], lang);
      if (!messages || !text) return;
      ids.forEach((id) => {
        if (Object.prototype.hasOwnProperty.call(messages, id)) {
          messages[id] = text;
          changed += 1;
        }
      });
    });
  });
  return changed;
};

/**
 * El nombre de la marca sustituye al de la base de Noname en el login
 * (`general.project-name`) y en el pie (`general.copyright`, que empieza por
 * «Noname»), conservando el resto de la traducción.
 */
export const applyName = (appLocale, name) => {
  if (!appLocale || typeof name !== 'string' || !name.trim()) return;
  Object.keys(appLocale).forEach((lang) => {
    const messages = appLocale[lang] && appLocale[lang].messages;
    if (!messages) return;
    if (typeof messages['general.project-name'] === 'string') {
      messages['general.project-name'] = name;
    }
    if (typeof messages['general.copyright'] === 'string') {
      messages['general.copyright'] = messages['general.copyright'].replace(
        'Noname',
        name
      );
    }
  });
};
